import AppStack from './app_stack';
import AppState from './app_state';
import DeleteBundleVersionService from './deleteBundleVersion/delete.bundle.version.service';
import TooltipConstants from '../constants/tooltips.constants';
import AppStorage from './app_storage';
import SignBundleVersionService from './signBundleVersionService/sign.bundle.version.service';
import StopBundleVersionDistributionsService from './stopBundleVersionDistributions/stop.bundle.versions.distributions.service';
import {AdvancedStringMatch} from './advanced_string_match';
import ExceptionHandlerDecorator from './exception.handler.decorator';
import DeleteEntityService from './delete.entity.service';
import DistributeService from './distributeBundleVersion/distribute.bundle.version.service';
import IntervalService from './interval.service';
import ValidationsService from "./validations.service";

export const MODULE_DISTRIBUTION_SERVICES = 'distribution.services';
angular.module(MODULE_DISTRIBUTION_SERVICES, ['ui.router', 'toaster'])
    .constant('TOOLTIPS', TooltipConstants)
    .service('AppState', AppState)
    .service('AppStack', AppStack)
    .service('AppStorage', AppStorage)
    .service('AdvancedStringMatch', AdvancedStringMatch)
    .service(DeleteEntityService.META.name, DeleteEntityService)
    .service(DistributeService.META.name, DistributeService)
    .service(IntervalService.META.name, IntervalService)
    .service(ValidationsService.META.name, ValidationsService)
    .service(DeleteBundleVersionService.META.name, DeleteBundleVersionService)
    .service(StopBundleVersionDistributionsService.META.name, StopBundleVersionDistributionsService)
    .service(SignBundleVersionService.META.name, SignBundleVersionService)
    .config(ExceptionHandlerDecorator);



// WEBPACK FOOTER //
// ./modules/distribution/services/app.services.module.js